<template>
  <svg class="svg-map-marker" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <path
      d="M32.62,33c1.82-2.73-3-5.24-10.71-5.61S6.43,28.91,4.62,31.65C3,34,6.46,36.23,12.49,37L13,40.74l5.31-3.46C25,37.1,31,35.34,32.62,33Z"
      transform="translate(12 0.41)" style="fill: gray; opacity: 0.5" />
    <circle cx="25" cy="20.59" r="7.59" style="fill: none" />
    <path
      d="M25,20.18A12,12,0,1,0,10.5,31.91a.5.5,0,0,1,.38.35L13,39.68l2.12-7.42a.5.5,0,0,1,.38-.35A12,12,0,0,0,25,20.18ZM13,28.77a8.59,8.59,0,1,1,8.59-8.59A8.6,8.6,0,0,1,13,28.77Z"
      transform="translate(12 0.41)" :style="`fill: ${color}`" />
    <circle cx="25" cy="20.59" r="7.59" style="fill: #fff" />
    <path
      d="M13,7.18a13,13,0,0,0-3,25.65l2.52,8.81a.5.5,0,0,0,1,0L16,32.83A13,13,0,0,0,13,7.18Zm2.5,24.74a.5.5,0,0,0-.38.35L13,39.68l-2.12-7.42a.5.5,0,0,0-.38-.35,12,12,0,1,1,5,0ZM13,11.59a8.59,8.59,0,1,0,8.59,8.59A8.6,8.6,0,0,0,13,11.59Zm0,16.18a7.59,7.59,0,1,1,7.59-7.59A7.6,7.6,0,0,1,13,27.77Z"
      transform="translate(12 0.41)" style="fill: #231f20" />
    <rect width="50" height="50" style="fill: none" />
  </svg>
</template>

<script>
export default {
  name: 'mapMarkerSVG',
  props: {
    color: {
      type: String,
      default: '#231f20',
    },
  }
}
</script>

<style scoped>
.svg-map-marker {
}
</style>